import React, { useEffect, useState, useRef } from 'react';
import './BotTrainingPage.css';
import LinksComponent from './LinksComponent';
import FilesComponent from './FilesComponent';
import CustomLayout from '../../layouts/Customlayout';
import axios from 'axios';
import config from '../../config';
import closeIcon from '../../assets/botTrainingIcons/closeIcon.svg';
import ShopifyLinks from './ShopifyComponent';
import ZidComponent from './ZidComponent';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SallaComponent from './SallaComponent';
import TestbotPanel from './Components/TestBot';

const BotTraining = () => {
  const { t } = useTranslation();


  const [activeTab, setActiveTab] = useState('links');
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [testingMsgList, setTestingMsgList] = useState([{ message: t('botTrainingPage.initialBotMessage'), from_bot: true }]);
  const [testingMessage, setTestingMessage] = useState('');
  const [showTooltip, setShowTooltip] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode') || 'web-chat';
  const testingMsgListRef = useRef(null);

  const handleMouseMove = (e) => {
    setPosition({ x: e.clientX + 10, y: e.clientY + 10 });
  };

  const togglePanel = () => {
    setIsPanelOpen(!isPanelOpen);
    setTestingMsgList([{ message: t('botTrainingPage.initialBotMessage'), from_bot: true }]);
  };

  useEffect(() => {
    if (testingMsgListRef.current) {
      testingMsgListRef.current.scrollTop = testingMsgListRef.current.scrollHeight;
    }
  }, [testingMsgList?.length]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleSendTestingMsg();
  };

  const handleSendTestingMsg = () => {
    if (testingMessage.length > 0) {
      setTestingMsgList((prevList) => [...prevList, { message: testingMessage, from_bot: false }]);
      setTestingMessage('');
      setTestingMsgList((prevList) => [...prevList, { isTyping:true,message: '', from_bot: true }]);

      let formData = new FormData();
      formData.append('question', testingMessage);
      formData.append('testing_type', activeTab);

      const headers = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Token ${localStorage.getItem('token')}`,
          Accept: 'application/json'
        }
      };

      axios
        .post(`${config.apiUrl}bot-test-website/`, formData, headers)
        .then((res) => {
          setTestingMsgList((prevList) => {
            const updatedList = prevList.slice(0, prevList.length - 1);
            return [...updatedList, { message: res.data.data, from_bot: true }];
          });
          setTestingMessage('');
        })
        .catch((error) => {
          console.error('Error sending message:', error);
        });
    }
  };

  const UserInfo = JSON.parse(localStorage.getItem('UserObject'));
  const shopifyZid = UserInfo?.mode;

  const tabOptions = [
    { id: 'links', label: t('botTrainingPage.linksTab'), icon: 'https://cdn-icons-png.flaticon.com/512/3037/3037366.png' },
    { id: 'files', label: t('botTrainingPage.filesTab'), icon: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5afpx3wsQgzXLHss8vgGV55nP5_B6fdhK6w&s' },
    ...(shopifyZid === 'shopify'
      ? [
          {
            id: 'products',
            label: t('botTrainingPage.shopifyTab'),
            icon: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQjVS_XEsmNvLJnLEg3F_SkIwuL3rAEi--_r-bY28x1Wgmz5pKqOf5qQawM0S4W9yA3tIw&usqp=CAU'
          }
        ]
      : shopifyZid === 'zid'
      ? [
          {
            id: 'products_zid',
            label: t('botTrainingPage.zidTab'),
            icon: 'https://wasmenia.com/_next/image?url=https%3A%2F%2Fstrapi.wasmenia.com%2Fuploads%2Fzid_9f78064663.svg&w=828&q=75'
          }
        ]
      : shopifyZid === 'salla'
      ? [
          {
            id: 'products_salla',
            label: t('botTrainingPage.sallaTab'),
            icon: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRo3teW2vurxSMshxO76yIVK0eRKDlINJKE5dtrk1s9IxPwswoMmjij6xho6oZjTQkZllU&usqp=CAU' // You can change this icon if you have a preferred one
          }
        ]
      : [])
  ];
  

  return (
    <CustomLayout>
      <div className="container">
        <div className="header">
          <div className="header-title relative">
            <span>{t('botTrainingPage.title')}</span>
            <span
              className="header-info ml-2 cursor-help inline-flex items-center justify-center"
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
              onMouseMove={handleMouseMove}
            >
              ⓘ
              {showTooltip && (
                <div className="fixed z-50 w-64" style={{ left: `${position.x}px`, top: `${position.y}px` }}>
                  <div className="bg-white rounded-lg shadow-lg border border-gray-200">
                    <div className="p-3">
                      <h4 className="text-sm font-semibold text-gray-800 mb-2">
                        {t('botTrainingPage.tooltipTitle')}
                      </h4>
                      <p className="text-xs text-gray-600 leading-relaxed">
                        {t('botTrainingPage.tooltipDescription')}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </span>
          </div>
          
          { (activeTab === 'links' || activeTab === 'files') && (
          <button className="test-bot-button" onClick={togglePanel}>
            {t('botTrainingPage.testButton')}
          </button>
        ) }


        </div>

        <div className="flex flex-wrap gap-4 mt-6 mb-6">
          {tabOptions.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-4 py-2 rounded-full text-sm font-semibold flex items-center gap-2 shadow-md transition \
                ${activeTab === tab.id ? 'bg-[#7F28F8] text-white' : 'bg-gray-100 text-gray-700 hover:bg-[#EAE6FD] hover:text-[#7F28F8]'}`}
            >
              <img src={tab.icon} alt={`${tab.label} icon`} style={{ width: 20, height: 20 }} />
              <span>{tab.label}</span>
            </button>
          ))}
        </div>

        {activeTab === 'links' && <LinksComponent />}
        {activeTab === 'files' && <FilesComponent />}
        {activeTab === 'products' && <ShopifyLinks />}
        {activeTab === 'products_zid' && <ZidComponent />}
        {activeTab === 'products_salla' && <SallaComponent />}


        { (activeTab === 'links' || activeTab === 'files') && (     <TestbotPanel
            isPanelOpen={isPanelOpen}
            togglePanel={togglePanel}
            closeIcon={closeIcon}
            testingMsgList={testingMsgList}
            setTestingMessage={setTestingMessage}
            testingMessage={testingMessage}
            handleKeyPress={handleKeyPress}
            handleSendTestingMsg={handleSendTestingMsg}
            testingMsgListRef={testingMsgListRef}
          
          />)}


       

      </div>
    </CustomLayout>
  );
};

export default BotTraining;
